
// DashboardApprovalCard
// Renders the "Assignment + Approval" card — shows selected dashboard metadata
// and the Developer Approve / Admin Approve action buttons.
// All state and handlers are owned by ConsoleDashboard.tsx and passed in as props.

import React from 'react';
import { ConsoleDashboardSummary } from '../../../types';

interface DashboardApprovalCardProps {
  selectedDashboard: ConsoleDashboardSummary | null;
  isAdmin: boolean;
  userRole: string;
  approvingStage: 'developer' | 'admin' | '';
  handleDashboardApproval: (stage: 'developer' | 'admin') => Promise<void>;
  pushingToProd: boolean;
  handlePushToProd: () => Promise<void>;
}

const DashboardApprovalCard: React.FC<DashboardApprovalCardProps> = ({
  selectedDashboard,
  isAdmin,
  userRole,
  approvingStage,
  handleDashboardApproval,
  pushingToProd,
  handlePushToProd,
}) => {
  const canPushToProd = isAdmin || userRole === 'tableau_admin';
  return (
    <div className="console-card">
      <h2>Assignment + Approval</h2>
      {selectedDashboard ? (
        <div>
          <p>
            <strong>ID:</strong> {selectedDashboard.dashboard_id}
          </p>
          <p>
            <strong>Name:</strong> {selectedDashboard.name}
          </p>
          <p>
            <strong>Status:</strong> {selectedDashboard.status}
          </p>
          <p>
            <strong>Approval:</strong> {selectedDashboard.approval_status || 'draft'}
          </p>
          <p>
            <strong>Primary:</strong> {selectedDashboard.primary_developer_email || '-'}
          </p>
          <p>
            <strong>Secondary:</strong> {selectedDashboard.secondary_developer_email || '-'}
          </p>
          <p>
            <strong>Updated By:</strong> {selectedDashboard.updated_by || '-'}
          </p>
          <div className="actions-row">
            <button
              type="button"
              onClick={() => void handleDashboardApproval('developer')}
              disabled={approvingStage === 'developer'}
            >
              {approvingStage === 'developer' ? 'Submitting...' : 'Developer Approve'}
            </button>
            {isAdmin ? (
              <button
                type="button"
                onClick={() => void handleDashboardApproval('admin')}
                disabled={approvingStage === 'admin'}
              >
                {approvingStage === 'admin' ? 'Submitting...' : 'Admin Approve'}
              </button>
            ) : null}
            {canPushToProd ? (
              <button
                type="button"
                onClick={() => void handlePushToProd()}
                disabled={pushingToProd}
              >
                {pushingToProd ? 'Pushing...' : 'Push To Production'}
              </button>
            ) : null}
          </div>
        </div>
      ) : (
        <p>No dashboard selected.</p>
      )}
    </div>
  );
};

export default DashboardApprovalCard;